module.exports = {
	"articleTitle1": "Panel discusses implications of C.C. Little building's eponym ",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "CC Little Science Building",
	"articleLink1": "https://www.michigandaily.com/section/campus-life/panel-debates-merits-cc-littles-legacy-eugenicist-and-university-president",
	"articleLink2": "https://www.michigandaily.com/section/viewpoints/op-ed-cc-little-naming-buildings-eugenics",
	"articleSnippet1": "Apr 11, 2017 ... LSA student Josh Hasler speaks at The Power of Place-Naming: C.C. Little, \nEugenics, and the University of Michigan event in Hatcher on ...",
	"articleSnippet2": "Apr 17, 2016 ... Clarence Cook Little's name should be removed from the University of Michigan's \nscience classroom building. The building bearing his name ...",
	"totalMisc": 0,
	"articleTitle2": "Op-Ed: Questioning C.C. Little's legacy ",
	"address": "1100 University Ave, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170126/kev.NEW_.CCLittle.1.26.17002_0.jpg?itok=Xprro-Sv",
			"author": "Kevin Zheng",
			"caption": "The C.C. Little Building is named after former University president Clarence Cook Little who became a controversial figure for his outspoken favor of eugenics and euthanasia."
		}
	],
	"position": {
		"lat": 42.277812,
		"lng": -83.735594
	},
	"tips": [],
	"bathroomrating": [],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/cclittlebuilding.json
// module id = 844
// module chunks = 0